module.exports = __webpack_public_path__ + "static/media/c-3po.a2d24948.png";